import {Component} from "@angular/core";
import {Service} from "@edp-models/service.model";

@Component({
    selector: "create-request-first-step",
    templateUrl: "./create-request-first-step.component.html",
    styleUrls: ["./create-request-first-step.component.scss"]
})

export class CreateRequestFirstStep {
    public selectedService: Service;

    public setSelectedService(service: Service) {
        this.selectedService = service;
    }
}
